import React, { useRef } from 'react';

const CSS = require('./SelectMenuItem.module.scss');

function SelectMenuItem({ selectedItem, options, onSelect, label }) {
  const selectRef = useRef(null);

  const onChange = (event) => {
    onSelect(event.target.value);
  };

  return (
    <div className={CSS.SelectMenuItem}>
      <span className={CSS.Label}>{label}</span>
      <select
        className={CSS.Select}
        value={selectedItem}
        onChange={onChange}
        ref={selectRef}
      >
        {options.map(({ value, label }) => {
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default SelectMenuItem;
